import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useAssociatedPeople(occurrenceCode) {
  return useQuery({
    queryKey: ['associatedPeople', occurrenceCode],
    queryFn: () => {
      return briefingApi
        .get(`niche/occurrences/${occurrenceCode}?entity=people`, {
          timeout: false,
        })
        .json();
    },
    enabled: !!occurrenceCode,
    staleTime: 30 * (60 * 1000),
    cacheTime: 35 * (60 * 1000),
  });
}
